import { M3PDinamByActividad } from "./m3-pdinam-by-actividad";

export class M3PEncFP {
    public Valor:number;
    public Descripcion:string;
    public Estado:string;
    public IdTipoPago:number; //1: Efectivo 2: Tarjeta de crÃ©dito 3: Tarjeta Debito 4: PSE
    public ID:number;
    public ValCambio:number;
    public ValOtraClasi:number =0;
    public M3PDinamByActividad = new Array<M3PDinamByActividad>();


    //Variables SoloFront
    public APLCambio:string;
    public APLFidelizacion:string;
    public dejar_borrar:boolean = true;

}